module.exports = __webpack_public_path__ + "img/コンピュータのしくみII_1_8_3.7b2860fd.jpg";